import React from 'react';
import {
  Menu,
  MenuItem,
  ListItemIcon,
  Typography,
} from '@mui/material';

const ReusableMenu = ({
  anchorEl,
  open,
  onClose,
  menuItems = [],
  sx = {},
  anchorOrigin,
  transformOrigin,
  selectedValue = null, // Added to track selected item
  selectedIndex = null, // Alternative way to track by index
}) => {
  return (
    <Menu
      anchorEl={anchorEl}
      open={open}
      onClose={onClose}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      PaperProps={{
        sx: {
          width: 220,
          borderRadius: '8px',
          border: '1px solid #8C8C8C',
          boxShadow: '0px 2px 8px 0px #0000001A',
          p: 1,
        },
      }}
      MenuListProps={{
        disablePadding: true,
        
      }}
      sx={{...sx}}
    >
      {menuItems.map((item, index) => {
        // Determine if this item is selected
        const isSelected = selectedValue !== null 
          ? item.value === selectedValue 
          : selectedIndex !== null 
          ? index === selectedIndex
          : false;

        return (
          <MenuItem
              key={index}
              onClick={item.onClick}
              autoFocus={false}
              autoFocusItem={false}
              sx={{
                  px: 0,
                  py: {xs: 0, md:1},
                  gap: 1,
                  fontSize: 14,
                  borderRadius: '8px',
                  color: isSelected ? '#995A00' : '#333', // Selected item has blue color
                  backgroundColor:  isSelected ? '#F7F7F7'  : 'transparent', // Selected item background
                  '&:hover': {
                      backgroundColor: isSelected ? '#F7F7F7' : '#f5f5f5', // Different hover for selected
                  },
                  minHeight: '32px',
              }}
          >
            {item.icon && (
              <ListItemIcon
                sx={{
                  minWidth: 32,
                  color: isSelected ? '#995A00': '#333',
                  borderRadius: '8px',
                }}
              >
                {item.icon}
              </ListItemIcon>
            )}
            <Typography 
              variant="body2" 
              sx={{ 
                px: 1,
              }}
            >
              {item.label}
            </Typography>
          </MenuItem>
        );
      })}
    </Menu>
  );
};

export default ReusableMenu;
